import React from "react";

import PropTypes from "prop-types";

import { Box } from "@material-ui/core";

import { Small } from "components/atoms/Typography";

import CustomerFileTagsDialog from "pages/customerFiles/CustomerFilesTags/CustomerFileTagsDialog";

import { useCustomerFileTags } from "utils/hooks/useCustomerFileTags";

const CustomerFilesTagsField = ({ canEdit = false, record = {}, updateCustomerFileDetail }) => {
  const { tags, isLoading, isError } = useCustomerFileTags();
  const patchCustomerFileTags = (tags) => updateCustomerFileDetail(record.id, { customer_file_tags: tags });
  return (
    <Box alignItems={"center"} display="flex" flexWrap="wrap" justifyContent="flex-start" mt={1}>
      {isError && <Small>Erreur lors du chargement des tags</Small>}
      {isLoading && <Small>Chargement des tags...</Small>}
      {tags && (
        <CustomerFileTagsDialog
          isTagEditionEnabled={canEdit}
          customerFile={record}
          fileTags={tags || []}
          loadingWorkshopFileTags={isLoading}
          handleSaveTags={patchCustomerFileTags}
        />
      )}
    </Box>
  );
};

CustomerFilesTagsField.propTypes = {
  customerFilesTags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      text: PropTypes.string,
      color: PropTypes.string,
    })
  ),
};

export default CustomerFilesTagsField;
